export enum DeleteAccountErrorKind {
  RequiresRecentLogin = 'requires-recent-login',
  NoUser = 'no-user',
  Unknown = 'unknown',
}

export class DeleteAccountError extends Error {
  constructor(
    public readonly kind: DeleteAccountErrorKind,
    options?: ErrorOptions,
  ) {
    super(`Delete account failed: ${kind}`, options);
    this.name = 'DeleteAccountError';
  }
}
